export default "__VITE_ASSET__CJx5YkeS__"